/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancellationRequestEntryInputList,
  ErrorList,
  Order,
  OrderComment,
  OrderHistoryList,
  SAPOrderAttachmentList,
  SAPOrderSubsequentDocument,
  SAPOrderSubsequentDocumentEntry,
} from '../models';
import {
    CancellationRequestEntryInputListFromJSON,
    CancellationRequestEntryInputListToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
    OrderFromJSON,
    OrderToJSON,
    OrderCommentFromJSON,
    OrderCommentToJSON,
    OrderHistoryListFromJSON,
    OrderHistoryListToJSON,
    SAPOrderAttachmentListFromJSON,
    SAPOrderAttachmentListToJSON,
    SAPOrderSubsequentDocumentFromJSON,
    SAPOrderSubsequentDocumentToJSON,
    SAPOrderSubsequentDocumentEntryFromJSON,
    SAPOrderSubsequentDocumentEntryToJSON,
} from '../models';

export interface AddACommentToOrderRequest {
    baseSiteId: string;
    code: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
    orderComment?: OrderComment;
}

export interface AddACommentToOrder1Request {
    baseSiteId: string;
    code: string;
    rekvisition: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface CountUserOrdersRequest {
    baseSiteId: string;
    userId: string;
    statuses?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface DoCancelOrderRequest {
    baseSiteId: string;
    code: string;
    userId: string;
    cancellationRequestEntryInputList: CancellationRequestEntryInputList;
    sapCommerceCloudCustomerId?: string;
}

export interface GetOrderRequest {
    baseSiteId: string;
    code: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserOrderAttachmentBinaryRequest {
    attachmentId: string;
    baseSiteId: string;
    code: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserOrderAttachmentsRequest {
    baseSiteId: string;
    code: string;
    userId: string;
    currentPage?: number;
    fields?: string;
    pageSize?: number;
    sort?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserOrderHistoryRequest {
    baseSiteId: string;
    userId: string;
    currentPage?: number;
    fields?: string;
    pageSize?: number;
    sort?: string;
    statuses?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserOrderSubsequentDocumentEntriesRequest {
    baseSiteId: string;
    code: string;
    documentCategory: string;
    documentId: string;
    userId: string;
    currentPage?: number;
    fields?: string;
    pageSize?: number;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserOrderSubsequentDocumentsRequest {
    baseSiteId: string;
    code: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserOrdersRequest {
    baseSiteId: string;
    code: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface MediqPlaceOrderRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
    orderComment?: OrderComment;
}

export interface PaymentAuthorizedOrderPlacementRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

/**
 * OrdersApi - interface
 * 
 * @export
 * @interface OrdersApiInterface
 */
export interface OrdersApiInterface {
    /**
     * Authorizes the cart and add the comment. The response is created 201
     * @summary Add a comment to order
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order code
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {OrderComment} [orderComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    addACommentToOrderRaw(requestParameters: AddACommentToOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * Add a comment to order
     */
    addACommentToOrder(requestParameters: AddACommentToOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * @summary Add a comment to order
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order code
     * @param {string} rekvisition Rekvisition to the order
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    addACommentToOrder1Raw(requestParameters: AddACommentToOrder1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * Add a comment to order
     */
    addACommentToOrder1(requestParameters: AddACommentToOrder1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves the total number of orders for a customer in the response header, under the \"x-total-count\" attribute.
     * @summary Retrieves the total number of orders for a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    countUserOrdersRaw(requestParameters: CountUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Retrieves the total number of orders for a customer in the response header, under the \"x-total-count\" attribute.
     * Retrieves the total number of orders for a customer.
     */
    countUserOrders(requestParameters: CountUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Cancels an order, completely or partially. For a complete cancellation, add all the order entry numbers and quantities in the request body. For partial cancellation, only add the order entry numbers and quantities to be cancelled.
     * @summary Cancels an order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order code
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {CancellationRequestEntryInputList} cancellationRequestEntryInputList 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    doCancelOrderRaw(requestParameters: DoCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Cancels an order, completely or partially. For a complete cancellation, add all the order entry numbers and quantities in the request body. For partial cancellation, only add the order entry numbers and quantities to be cancelled.
     * Cancels an order.
     */
    doCancelOrder(requestParameters: DoCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves the details of the order using the Globally Unique Identifier (GUID) or the order code. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * @summary Retrieves the order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order GUID or order code.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getOrderRaw(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * Retrieves the details of the order using the Globally Unique Identifier (GUID) or the order code. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order.
     */
    getOrder(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

    /**
     * Get content attachment of an order. The response will be a binary file with an appropriate `Content-Type` header.
     * @summary Get binary attachment of an order
     * @param {string} attachmentId Attachment ID
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order Code
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getUserOrderAttachmentBinaryRaw(requestParameters: GetUserOrderAttachmentBinaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     * Get content attachment of an order. The response will be a binary file with an appropriate `Content-Type` header.
     * Get binary attachment of an order
     */
    getUserOrderAttachmentBinary(requestParameters: GetUserOrderAttachmentBinaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * Returns attachments based on a specific order code. The response contains list of attachment information.
     * @summary Get attachments for an order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order Code
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getUserOrderAttachmentsRaw(requestParameters: GetUserOrderAttachmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPOrderAttachmentList>>;

    /**
     * Returns attachments based on a specific order code. The response contains list of attachment information.
     * Get attachments for an order.
     */
    getUserOrderAttachments(requestParameters: GetUserOrderAttachmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPOrderAttachmentList>;

    /**
     * Retrieves the order history of a customer. The response may display the results across multiple pages, when applicable.
     * @summary Retrieves the order history of a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] Current result page. Default value is 0.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {string} [statuses] Filters orders with specified status(es). For example, statuses &#x3D; CANCELLED returns CANCELLED orders. To filter multiple statuses, separate statuses with \&quot;,\&quot; and all orders with these statuses will be returned. For example, statuses &#x3D; CANCELLED,COMPLETED,READY returns all orders with statuses CANCELLED, COMPLETED, and READY. Options available are: CANCELLING, CHECKED_VALID, CREATED, OPEN, READY, CHECKED_INVALID, ON_HOLD, ON_VALIDATION, PENDING_APPROVAL, SUSPENDED, COMPLETED, PAYMENT_AUTHORIZED, PENDING_APPROVAL_FROM_MERCHANT, CANCELLED, PAYMENT_NOT_AUTHORIZED, PENDING_QUOTE, APPROVED_QUOTE, PAYMENT_AMOUNT_RESERVED, PAYMENT_AMOUNT_NOT_RESERVED, REJECTED_QUOTE, APPROVED, PAYMENT_CAPTURED, PAYMENT_NOT_CAPTURED, REJECTED, APPROVED_BY_MERCHANT, FRAUD_CHECKED, ORDER_SPLIT, REJECTED_BY_MERCHANT, ASSIGNED_TO_ADMIN, PROCESSING_ERROR, B2B_PROCESSING_ERROR, WAIT_FRAUD_MANUAL_CHECK, PAYMENT_NOT_VOIDED, TAX_NOT_VOIDED, TAX_NOT_COMMITTED, TAX_NOT_REQUOTED 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getUserOrderHistoryRaw(requestParameters: GetUserOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderHistoryList>>;

    /**
     * Retrieves the order history of a customer. The response may display the results across multiple pages, when applicable.
     * Retrieves the order history of a customer.
     */
    getUserOrderHistory(requestParameters: GetUserOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderHistoryList>;

    /**
     * Returns a list of Subsequent Documents entries based on a Document ID and Category
     * @summary Get entries of an order\'s subsequent document.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order Code
     * @param {string} documentCategory Document Category
     * @param {string} documentId Document Id
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getUserOrderSubsequentDocumentEntriesRaw(requestParameters: GetUserOrderSubsequentDocumentEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SAPOrderSubsequentDocumentEntry>>>;

    /**
     * Returns a list of Subsequent Documents entries based on a Document ID and Category
     * Get entries of an order\'s subsequent document.
     */
    getUserOrderSubsequentDocumentEntries(requestParameters: GetUserOrderSubsequentDocumentEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SAPOrderSubsequentDocumentEntry>>;

    /**
     * Returns a list of Subsequent Documents based on a specific order code.
     * @summary Get subsequent document flow for an order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order Code
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getUserOrderSubsequentDocumentsRaw(requestParameters: GetUserOrderSubsequentDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SAPOrderSubsequentDocument>>>;

    /**
     * Returns a list of Subsequent Documents based on a specific order code.
     * Get subsequent document flow for an order.
     */
    getUserOrderSubsequentDocuments(requestParameters: GetUserOrderSubsequentDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SAPOrderSubsequentDocument>>;

    /**
     * Retrieves the details of the order. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * @summary Retrieves the order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order GUID or order code.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getUserOrdersRaw(requestParameters: GetUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * Retrieves the details of the order. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order.
     */
    getUserOrders(requestParameters: GetUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

    /**
     * Authorizes the cart and places the order. The response contains the new order data.
     * @summary Place a order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart code for logged in user, cart GUID for guest checkout
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {OrderComment} [orderComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    mediqPlaceOrderRaw(requestParameters: MediqPlaceOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * Authorizes the cart and places the order. The response contains the new order data.
     * Place a order.
     */
    mediqPlaceOrder(requestParameters: MediqPlaceOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

    /**
     * This API supports placing order with asynchronous payment patterns like iFrame, hosted payment page and hosted field. With these payment patterns, the payment authorization is done independently with order placement API and the payment result is handled through asynchronous notifications. For instant payment method and delayed payment method, the order is placed directly after customers have successfully submitted the payments but the order process shall be in paused state until the payment notification is received and processed on Commerce side.  Note: API can only be used when the baseStore\'s payment provider is configured as OPF, and completion of OPF-related order processes is required; otherwise, it will throw an exception. 
     * @summary Place an order with authorized payment.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart code for logged in user, cart GUID for guest checkout
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    paymentAuthorizedOrderPlacementRaw(requestParameters: PaymentAuthorizedOrderPlacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * This API supports placing order with asynchronous payment patterns like iFrame, hosted payment page and hosted field. With these payment patterns, the payment authorization is done independently with order placement API and the payment result is handled through asynchronous notifications. For instant payment method and delayed payment method, the order is placed directly after customers have successfully submitted the payments but the order process shall be in paused state until the payment notification is received and processed on Commerce side.  Note: API can only be used when the baseStore\'s payment provider is configured as OPF, and completion of OPF-related order processes is required; otherwise, it will throw an exception. 
     * Place an order with authorized payment.
     */
    paymentAuthorizedOrderPlacement(requestParameters: PaymentAuthorizedOrderPlacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI implements OrdersApiInterface {

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * Add a comment to order
     */
    async addACommentToOrderRaw(requestParameters: AddACommentToOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling addACommentToOrder.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling addACommentToOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling addACommentToOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/comment`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCommentToJSON(requestParameters.orderComment),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * Add a comment to order
     */
    async addACommentToOrder(requestParameters: AddACommentToOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addACommentToOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * Add a comment to order
     */
    async addACommentToOrder1Raw(requestParameters: AddACommentToOrder1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling addACommentToOrder1.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling addACommentToOrder1.');
        }

        if (requestParameters.rekvisition === null || requestParameters.rekvisition === undefined) {
            throw new runtime.RequiredError('rekvisition','Required parameter requestParameters.rekvisition was null or undefined when calling addACommentToOrder1.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling addACommentToOrder1.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.rekvisition !== undefined) {
            queryParameters['rekvisition'] = requestParameters.rekvisition;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/rekvisition`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authorizes the cart and add the comment. The response is created 201
     * Add a comment to order
     */
    async addACommentToOrder1(requestParameters: AddACommentToOrder1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addACommentToOrder1Raw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the total number of orders for a customer in the response header, under the \"x-total-count\" attribute.
     * Retrieves the total number of orders for a customer.
     */
    async countUserOrdersRaw(requestParameters: CountUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling countUserOrders.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling countUserOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.statuses !== undefined) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieves the total number of orders for a customer in the response header, under the \"x-total-count\" attribute.
     * Retrieves the total number of orders for a customer.
     */
    async countUserOrders(requestParameters: CountUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.countUserOrdersRaw(requestParameters, initOverrides);
    }

    /**
     * Cancels an order, completely or partially. For a complete cancellation, add all the order entry numbers and quantities in the request body. For partial cancellation, only add the order entry numbers and quantities to be cancelled.
     * Cancels an order.
     */
    async doCancelOrderRaw(requestParameters: DoCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling doCancelOrder.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling doCancelOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling doCancelOrder.');
        }

        if (requestParameters.cancellationRequestEntryInputList === null || requestParameters.cancellationRequestEntryInputList === undefined) {
            throw new runtime.RequiredError('cancellationRequestEntryInputList','Required parameter requestParameters.cancellationRequestEntryInputList was null or undefined when calling doCancelOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/cancellation`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancellationRequestEntryInputListToJSON(requestParameters.cancellationRequestEntryInputList),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels an order, completely or partially. For a complete cancellation, add all the order entry numbers and quantities in the request body. For partial cancellation, only add the order entry numbers and quantities to be cancelled.
     * Cancels an order.
     */
    async doCancelOrder(requestParameters: DoCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.doCancelOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the details of the order using the Globally Unique Identifier (GUID) or the order code. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order.
     */
    async getOrderRaw(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getOrder.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orders/{code}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Retrieves the details of the order using the Globally Unique Identifier (GUID) or the order code. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order.
     */
    async getOrder(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.getOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get content attachment of an order. The response will be a binary file with an appropriate `Content-Type` header.
     * Get binary attachment of an order
     */
    async getUserOrderAttachmentBinaryRaw(requestParameters: GetUserOrderAttachmentBinaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling getUserOrderAttachmentBinary.');
        }

        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserOrderAttachmentBinary.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getUserOrderAttachmentBinary.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserOrderAttachmentBinary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/attachments/{attachmentId}/download`.replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))).replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get content attachment of an order. The response will be a binary file with an appropriate `Content-Type` header.
     * Get binary attachment of an order
     */
    async getUserOrderAttachmentBinary(requestParameters: GetUserOrderAttachmentBinaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getUserOrderAttachmentBinaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns attachments based on a specific order code. The response contains list of attachment information.
     * Get attachments for an order.
     */
    async getUserOrderAttachmentsRaw(requestParameters: GetUserOrderAttachmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPOrderAttachmentList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserOrderAttachments.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getUserOrderAttachments.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserOrderAttachments.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/attachments`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SAPOrderAttachmentListFromJSON(jsonValue));
    }

    /**
     * Returns attachments based on a specific order code. The response contains list of attachment information.
     * Get attachments for an order.
     */
    async getUserOrderAttachments(requestParameters: GetUserOrderAttachmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPOrderAttachmentList> {
        const response = await this.getUserOrderAttachmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the order history of a customer. The response may display the results across multiple pages, when applicable.
     * Retrieves the order history of a customer.
     */
    async getUserOrderHistoryRaw(requestParameters: GetUserOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderHistoryList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserOrderHistory.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserOrderHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.statuses !== undefined) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderHistoryListFromJSON(jsonValue));
    }

    /**
     * Retrieves the order history of a customer. The response may display the results across multiple pages, when applicable.
     * Retrieves the order history of a customer.
     */
    async getUserOrderHistory(requestParameters: GetUserOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderHistoryList> {
        const response = await this.getUserOrderHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of Subsequent Documents entries based on a Document ID and Category
     * Get entries of an order\'s subsequent document.
     */
    async getUserOrderSubsequentDocumentEntriesRaw(requestParameters: GetUserOrderSubsequentDocumentEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SAPOrderSubsequentDocumentEntry>>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserOrderSubsequentDocumentEntries.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getUserOrderSubsequentDocumentEntries.');
        }

        if (requestParameters.documentCategory === null || requestParameters.documentCategory === undefined) {
            throw new runtime.RequiredError('documentCategory','Required parameter requestParameters.documentCategory was null or undefined when calling getUserOrderSubsequentDocumentEntries.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling getUserOrderSubsequentDocumentEntries.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserOrderSubsequentDocumentEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/subsequentDocuments/{documentCategory}/{documentId}/entries`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"documentCategory"}}`, encodeURIComponent(String(requestParameters.documentCategory))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SAPOrderSubsequentDocumentEntryFromJSON));
    }

    /**
     * Returns a list of Subsequent Documents entries based on a Document ID and Category
     * Get entries of an order\'s subsequent document.
     */
    async getUserOrderSubsequentDocumentEntries(requestParameters: GetUserOrderSubsequentDocumentEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SAPOrderSubsequentDocumentEntry>> {
        const response = await this.getUserOrderSubsequentDocumentEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of Subsequent Documents based on a specific order code.
     * Get subsequent document flow for an order.
     */
    async getUserOrderSubsequentDocumentsRaw(requestParameters: GetUserOrderSubsequentDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SAPOrderSubsequentDocument>>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserOrderSubsequentDocuments.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getUserOrderSubsequentDocuments.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserOrderSubsequentDocuments.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}/subsequentDocuments`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SAPOrderSubsequentDocumentFromJSON));
    }

    /**
     * Returns a list of Subsequent Documents based on a specific order code.
     * Get subsequent document flow for an order.
     */
    async getUserOrderSubsequentDocuments(requestParameters: GetUserOrderSubsequentDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SAPOrderSubsequentDocument>> {
        const response = await this.getUserOrderSubsequentDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the details of the order. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order.
     */
    async getUserOrdersRaw(requestParameters: GetUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserOrders.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getUserOrders.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/{code}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Retrieves the details of the order. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order.
     */
    async getUserOrders(requestParameters: GetUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.getUserOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Authorizes the cart and places the order. The response contains the new order data.
     * Place a order.
     */
    async mediqPlaceOrderRaw(requestParameters: MediqPlaceOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling mediqPlaceOrder.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling mediqPlaceOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling mediqPlaceOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.cartId !== undefined) {
            queryParameters['cartId'] = requestParameters.cartId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCommentToJSON(requestParameters.orderComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Authorizes the cart and places the order. The response contains the new order data.
     * Place a order.
     */
    async mediqPlaceOrder(requestParameters: MediqPlaceOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.mediqPlaceOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This API supports placing order with asynchronous payment patterns like iFrame, hosted payment page and hosted field. With these payment patterns, the payment authorization is done independently with order placement API and the payment result is handled through asynchronous notifications. For instant payment method and delayed payment method, the order is placed directly after customers have successfully submitted the payments but the order process shall be in paused state until the payment notification is received and processed on Commerce side.  Note: API can only be used when the baseStore\'s payment provider is configured as OPF, and completion of OPF-related order processes is required; otherwise, it will throw an exception. 
     * Place an order with authorized payment.
     */
    async paymentAuthorizedOrderPlacementRaw(requestParameters: PaymentAuthorizedOrderPlacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling paymentAuthorizedOrderPlacement.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling paymentAuthorizedOrderPlacement.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentAuthorizedOrderPlacement.');
        }

        const queryParameters: any = {};

        if (requestParameters.cartId !== undefined) {
            queryParameters['cartId'] = requestParameters.cartId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/orders/paymentAuthorizedOrderPlacement`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * This API supports placing order with asynchronous payment patterns like iFrame, hosted payment page and hosted field. With these payment patterns, the payment authorization is done independently with order placement API and the payment result is handled through asynchronous notifications. For instant payment method and delayed payment method, the order is placed directly after customers have successfully submitted the payments but the order process shall be in paused state until the payment notification is received and processed on Commerce side.  Note: API can only be used when the baseStore\'s payment provider is configured as OPF, and completion of OPF-related order processes is required; otherwise, it will throw an exception. 
     * Place an order with authorized payment.
     */
    async paymentAuthorizedOrderPlacement(requestParameters: PaymentAuthorizedOrderPlacementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.paymentAuthorizedOrderPlacementRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
